import React from "react";

const Methodology = () => {
  return (
    <div className="methodology-container">
      <div className="methodology-content">

        
        

      <p>
        For example, strong anti-corruption disclosures enhance a company’s credibility by demonstrating consistency in reporting, reducing the risk of misinformation, strengthening investor confidence, and supporting long-term stakeholder engagement.
      </p>

      <p>
        TRAC’s assessment framework covers several critical dimensions, including anti-corruption reporting, organizational transparency, country-by-country reporting, and domestic financial reporting. These indicators ensure that companies are evaluated against globally recognized benchmarks of transparency.
      </p>

      <p>
        In addition, the assessment examines policies related to gender and non-discrimination, procurement practices involving government contracts, and human rights and corporate responsibility. These areas are aligned with TRAC assessments conducted in other countries while also reflecting Pakistan’s unique socio-economic and regulatory environment.
      </p>

      <p>
        This localized approach highlights the need for companies to adopt more inclusive and transparent practices that address domestic challenges while remaining consistent with international standards.
      </p>

      <p>
        By evaluating these dimensions, TRAC provides a comprehensive view of corporate disclosure. It identifies both strengths and areas for improvement, encouraging companies to enhance ethical practices and transparency standards. These insights contribute to a more competitive and responsible business environment where organizations prioritize effective disclosure within their operational frameworks.
      </p>

        <h2>The Significance of TRAC</h2>

        <p>
            Transparency International’s Global Corruption Barometer 2017 identified Pakistan as the 4th most corrupt country in the Asia-Pacific region. According to Transparency International’s Corruption Perceptions Index (CPI) 2023, Pakistan scored <strong>29 out of 100</strong>, ranking <strong>133 out of 180 countries</strong>. The score reflects perceived levels of corruption in the public sector, while the ranking indicates Pakistan’s relative global position.
          </p>

          <p>
            Corruption remains a significant challenge in Pakistan, with various forms of bribery often considered socially acceptable across different sectors. This is further highlighted by the National Corruption Perception Survey 2023 by Transparency International Pakistan. The private sector is equally affected, as many companies fail to comprehensively disclose anti-corruption measures or lack robust policies to mitigate corruption risks within their organizations.
          </p>

          <p>
            Corruption in the private sector undermines investor confidence and discourages both foreign direct investment (FDI) and local investment by increasing perceived business risks. It also raises the cost of doing business, as companies may resort to unethical practices such as bribery and facilitation payments. Additionally, corruption contributes to significant tax revenue losses and weakens financial systems.
          </p>

          <p>
            Pakistan’s tax-to-GDP ratio stood at <strong>10.0%</strong> in 2023, reflecting limited revenue generation capacity. As a result, the country relies heavily on domestic borrowing to meet its fiscal needs. Addressing corruption is therefore critical to improving tax collection and strengthening economic stability. Beyond financial impacts, corruption damages both corporate reputations and the country’s overall image and economic performance.
          </p>

          <p>
            Companies that actively work to prevent and address corruption demonstrate a strong commitment to transparency and accountability. Implementing clear anti-corruption policies and effective internal controls helps minimize unethical practices and fosters trust among employees, management, and stakeholders. Such measures are essential for long-term sustainability and alignment with international best practices.
          </p>

        <h2>An Overview of the Results</h2>

       <p>
          The overall average score for the 69 companies evaluated in the TRAC 2024 Assessment is <strong>72.3%</strong>, indicating a moderate level of transparency in corporate disclosure practices. (One company, Pakgen Power Limited, requested exclusion from the assessment.)
        </p>

        <p>
          The lowest average score of <strong>47.28%</strong> was observed in anti-corruption programs, reflecting partial transparency. In contrast, organizational transparency scored <strong>90.54%</strong>, while domestic financial reporting achieved the highest score of <strong>94.35%</strong>, both indicating high levels of transparency.
        </p>

        <p>
          Companies scored <strong>68.84%</strong> in gender and non-discrimination policies, demonstrating moderate transparency, and <strong>60.43%</strong> in human rights and corporate responsibility, reflecting partial transparency.
        </p>

        <p>
          Notably, no category reached the thresholds for either full transparency or the lowest transparency level, indicating an overall balanced yet improvable performance across all areas.
        </p>

      </div>
    </div>
  );
};

export default Methodology;